import React, { useCallback } from 'react';

import { DateInput, IDateInputProps } from '@rbilabs/components-library';
import { FieldProps } from 'formik';
import { useIntl } from 'react-intl';

import { OptionalProps } from '@rbi-ctg/frontend';

export const FormikDateInput = ({
  field,
  form,
  label,
  autoComplete,
  ...props
}: FieldProps &
  OptionalProps<
    IDateInputProps,
    | 'label'
    | 'labelYear'
    | 'labelYearFormat'
    | 'labelMonth'
    | 'labelMonthFormat'
    | 'labelDay'
    | 'labelDayFormat'
  >) => {
  const { formatMessage } = useIntl();
  const handleInputChange = useCallback(
    e => {
      form.setFieldValue(e.target.name, e.target.value);
    },
    [form]
  );

  const errors = form.touched[field.name] ? (form.errors?.[field.name] as string) : undefined;

  return (
    <DateInput
      autoComplete={autoComplete}
      data-testid={field.name}
      {...field}
      label={label ?? ''}
      labelYear={formatMessage({ id: 'year' })}
      labelYearFormat={formatMessage({ id: 'yearPlaceholder' })}
      labelMonth={formatMessage({ id: 'month' })}
      labelMonthFormat={formatMessage({ id: 'monthPlaceholder' })}
      labelDay={formatMessage({ id: 'day' })}
      labelDayFormat={formatMessage({ id: 'dayPlaceholder' })}
      {...props}
      errorMessage={errors}
      onBlur={form.handleBlur}
      onChange={handleInputChange}
      month={form.values[field.name].month}
      day={form.values[field.name].day}
      year={form.values[field.name].year}
    />
  );
};
